<template>
    <div v-select-text="value" style="width: 800px; margin:0 auto; position: relative; border: 3px solid #efefef; padding: 20px; background-color: #fff;">
        <div class="title mb-4 text-xs-center">Ликвидация безграмотности в СССР в 20-30е годы</div>

        <p class="redline">
            Оценки среднего уровня грамотности населения в России в целом к 1914-1915 гг году достаточно сильно разнятся: от 35-38 % к 1915 году до 43% в 1917, но применительно только к европейской части России, исключаям из нее детей, не достигших 10 лет. Бывший министр просвещения П.Н. Игнатьев в своей статье приводил оценку в 56% грамотных от всего населения России (на 1916 год).По данным исследования Института этнологии и антропологии РАН под руководством д.и.н., профессора М. М. Громыко, реальная грамотность крестьян была заметно выше данных официальной статистики, поскольку многие (особенно старообрядцы) не считали нужным записывать при обследованиях свою грамотность, и по ряду других причин. Отмечается также, что тяга крестьян к грамоте, интерес к книгам и периодическим изданиям постоянно росли, особенно быстро после 1906 года.
        </p>
        <p class="redline">
            Ожидалось, что всеобщее начальное образование на территории европейской России будет достигнуто между 1919 и 1925 годами.
        </p>
        <p class="redline">
            Имевшие место в России в 1896-1917 гг неуклонный рост грамотности населения, быстрый рост числа начальных и средних школ и учащихся, средних и высших учебных заведений и числа студентов, а также техников, инженеров, специалистов во всех областях хозяйства и учёных, – эти процессы, лишь замедлившиеся в годы Первой мировой войны прервались и обрушились в годы Гражданской войны и массового голода начала 1920-х годы.
        </p>
        <p class="redline">
            Таблица Главлитпросвета от 1926 года.
        </p>

        <div class="text-xs-center">
            <img src="./i1.jpeg"/>
        </div>

        <p class="redline">
            Всего в 1917—27 годах было обучено грамоте до 10 млн взрослых, в том числе в РСФСР 5,5 млн.  Сам процесс ликвидации безграмотности, по данным Российской педагогической энциклопедии, завершился следующими результатами: "В конце 30-х годов достигнут уровень грамотности населения свыше 80 %. Ликвидация массовой неграмотности в СССР завершена после Великой Отечественной войны. Процесс становления полной грамотности завершался в конце 60-х и в 70-е годы: удельный вес лиц с образованием ниже законченного начального (в том числе и лиц без образования) составлял среди населения СССР в возрасте 10 лет и старше в 1959—32,9%, в 1970 — 22,4%, в 1979 — 11,3%".
        </p>
    </div>
</template>
<script>
    import SelectText from '@/directives/select-text.js'

    export default {
        props: {
            value: [Array]
        },
        directives: {
            SelectText
        }
    }
</script>
<style scoped></style>